(() => {
  if (window.AnoreaTryOnLoaded) return;
  window.AnoreaTryOnLoaded = true;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function initTryOn(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const modal = root.querySelector('[data-tryon-modal]');
    const openButton = root.querySelector('[data-tryon-open]');
    const closeButtons = root.querySelectorAll('[data-tryon-close]');
    const stage = root.querySelector('[data-tryon-stage]');
    const photo = root.querySelector('[data-tryon-photo]');
    const bracelet = root.querySelector('[data-tryon-bracelet]');
    const fileInputs = root.querySelectorAll('[data-tryon-file]');
    const toneButtons = root.querySelectorAll('[data-tryon-tone]');
    const scaleInput = root.querySelector('[data-tryon-scale]');
    const rotateInput = root.querySelector('[data-tryon-rotate]');
    const opacityInput = root.querySelector('[data-tryon-opacity]');
    const resetButton = root.querySelector('[data-tryon-reset]');

    let objectUrl = '';
    let state = {
      x: 0,
      y: 0,
      scale: 0.82,
      rotate: 0,
      opacity: 0.9,
      dragging: false,
      startX: 0,
      startY: 0,
      originX: 0,
      originY: 0,
    };

    function setTone(tone) {
      const src = tone === 'silver' ? root.dataset.silverSrc : root.dataset.goldSrc;
      bracelet.src = src;
      toneButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.tryonTone === tone);
        button.setAttribute('aria-pressed', button.dataset.tryonTone === tone ? 'true' : 'false');
      });
    }

    function render() {
      const stageRect = stage.getBoundingClientRect();
      state.x = clamp(state.x, -stageRect.width * 0.48, stageRect.width * 0.48);
      state.y = clamp(state.y, -stageRect.height * 0.48, stageRect.height * 0.48);
      bracelet.style.transform = `translate(-50%, -50%) translate(${state.x}px, ${state.y}px) rotate(${state.rotate}deg) scale(${state.scale})`;
      bracelet.style.opacity = state.opacity;
      if (scaleInput) scaleInput.value = state.scale;
      if (rotateInput) rotateInput.value = state.rotate;
      if (opacityInput) opacityInput.value = state.opacity;
    }

    function resetTransform() {
      state.x = 0;
      state.y = 0;
      state.scale = 0.82;
      state.rotate = 0;
      state.opacity = 0.9;
      render();
    }

    function openModal() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      render();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      fileInputs.forEach((input) => {
        input.value = '';
      });
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = '';
      }
      photo.removeAttribute('src');
      stage.classList.remove('is-loaded');
      resetTransform();
    }

    function setPhoto(file) {
      if (!file || !file.type || !file.type.startsWith('image/')) return;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      photo.src = objectUrl;
      stage.classList.add('is-loaded');
      resetTransform();
    }

    openButton.addEventListener('click', openModal);
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (!modal.hidden && event.key === 'Escape') closeModal();
    });

    fileInputs.forEach((input) => {
      input.addEventListener('change', (event) => {
        setPhoto(event.target.files && event.target.files[0]);
      });
    });

    toneButtons.forEach((button) => {
      button.addEventListener('click', () => setTone(button.dataset.tryonTone));
    });

    if (scaleInput) {
      scaleInput.addEventListener('input', () => {
        state.scale = Number(scaleInput.value);
        render();
      });
    }

    if (rotateInput) {
      rotateInput.addEventListener('input', () => {
        state.rotate = Number(rotateInput.value);
        render();
      });
    }

    if (opacityInput) {
      opacityInput.addEventListener('input', () => {
        state.opacity = Number(opacityInput.value);
        render();
      });
    }

    resetButton.addEventListener('click', resetTransform);

    stage.addEventListener('pointerdown', (event) => {
      state.dragging = true;
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.originX = state.x;
      state.originY = state.y;
      stage.setPointerCapture(event.pointerId);
    });

    stage.addEventListener('pointermove', (event) => {
      if (!state.dragging) return;
      state.x = state.originX + event.clientX - state.startX;
      state.y = state.originY + event.clientY - state.startY;
      render();
    });

    stage.addEventListener('pointerup', (event) => {
      state.dragging = false;
      stage.releasePointerCapture(event.pointerId);
    });

    stage.addEventListener('pointercancel', () => {
      state.dragging = false;
    });

    setTone(root.dataset.defaultTone === 'silver' ? 'silver' : 'gold');
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-anorea-tryon]').forEach(initTryOn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
